'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _spin = require('antd/lib/spin');

var _spin2 = _interopRequireDefault(_spin);

var _checkbox = require('antd/lib/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _user = require('../actions/user');

var _reduxRegexpRouter = require('redux-regexp-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormItem = _form2.default.Item;

var LoginForm = function (_React$Component) {
    _inherits(LoginForm, _React$Component);

    function LoginForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LoginForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.props.form.validateFields(function (err, values) {
                if (!err) {
                    _this.props.onLogin(values);
                }
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LoginForm, [{
        key: 'render',
        value: function render() {
            var getFieldDecorator = this.props.form.getFieldDecorator;

            return _react2.default.createElement(
                _form2.default,
                { onSubmit: this.handleSubmit, className: 'login-form' },
                _react2.default.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('username', {
                        rules: [{ required: true, message: 'Введите логин!' }]
                    })(_react2.default.createElement(_input2.default, { prefix: _react2.default.createElement(_icon2.default, { type: 'user', style: { fontSize: 13 } }), placeholder: '\u041B\u043E\u0433\u0438\u043D' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('password', {
                        rules: [{ required: true, message: 'Введите пароль!' }]
                    })(_react2.default.createElement(_input2.default, { prefix: _react2.default.createElement(_icon2.default, { type: 'lock', style: { fontSize: 13 } }), type: 'password',
                        placeholder: '\u041F\u0430\u0440\u043E\u043B\u044C' }))
                ),
                _react2.default.createElement(
                    FormItem,
                    null,
                    getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true
                    })(_react2.default.createElement(
                        _checkbox2.default,
                        null,
                        '\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043C\u0435\u043D\u044F'
                    )),
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', htmlType: 'submit', className: 'login-form-button' },
                        '\u0412\u043E\u0439\u0442\u0438'
                    )
                )
            );
        }
    }]);

    return LoginForm;
}(_react2.default.Component);

var WrappedLoginForm = _form2.default.create()(LoginForm);

var Login = function (_React$Component2) {
    _inherits(Login, _React$Component2);

    function Login() {
        var _ref2;

        var _temp2, _this2, _ret2;

        _classCallCheck(this, Login);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Login.__proto__ || Object.getPrototypeOf(Login)).call.apply(_ref2, [this].concat(args))), _this2), _this2.componentDidMount = function () {
            var _this2$props = _this2.props,
                user = _this2$props.user,
                dispatch = _this2$props.dispatch;

            if (user.refreshToken && user.rememberMe) {
                dispatch((0, _user.tryRefreshToken)(user.refreshToken));
            }
        }, _this2.onLogin = function (credentials) {
            var dispatch = _this2.props.dispatch;

            dispatch((0, _user.tryLogin)(credentials.username, credentials.password, credentials.remember));
        }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    _createClass(Login, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                config = _props.config,
                user = _props.user;

            return _react2.default.createElement(
                _spin2.default,
                { spinning: user.refreshToken && true },
                _react2.default.createElement(
                    'div',
                    { id: 'login-view' },
                    _react2.default.createElement(
                        _row2.default,
                        { type: 'flex', justify: 'space-around' },
                        _react2.default.createElement(
                            _col2.default,
                            { span: 5 },
                            _react2.default.createElement('img', { src: config.logo }),
                            _react2.default.createElement(WrappedLoginForm, { onLogin: this.onLogin })
                        )
                    )
                )
            );
        }
    }]);

    return Login;
}(_react2.default.Component);

(0, _reduxRegexpRouter.addRoutingContext)(Login);

exports.default = (0, _reactRedux.connect)(function (state) {
    return { config: state.config, user: state.user };
})(Login);
//# sourceMappingURL=Login.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/containers/Login.js
// module id = 603
// module chunks = 5